<!--
  How to install the changeling plugin, for Claude Code and Codex
  (docs/remote-relay.md, "Install"), from where it installs (relayText's
  SOURCE: this Changeling's own download), each command with its own copy
  button.
-->
<script lang="ts">
  import { copyText } from '../clipboard';
  import { install, INSTALL_NEEDS } from '../logic/relayText';
  const { fetch, harnesses, why } = install(location.origin);
  let copied = $state('');
  let error = $state('');
  async function copy(what: string, command: string) {
    if (await copyText(command)) { copied = what; error = ''; } else { copied = ''; error = 'Select and copy the command.'; }
  }
</script>
<div class="relay-install">
  {#if why}<p>{why}</p>{/if}
  {#if fetch}
    <p>{fetch.intro}</p>
    <div class="install-row">
      <pre><code>{fetch.command}</code></pre>
      <button class="btn small" aria-label="Copy the download command" onclick={() => copy('Download', fetch.command)}>{copied === 'Download' ? 'Copied' : 'Copy'}</button>
    </div>
    <p>Then add it to your agent:</p>
  {/if}
  {#each harnesses as { harness, command } (harness)}
    <div class="install-row">
      <span class="harness">{harness}</span>
      <pre><code>{command}</code></pre>
      <button class="btn small" aria-label="Copy the {harness} install command" onclick={() => copy(harness, command)}>{copied === harness ? 'Copied' : 'Copy'}</button>
    </div>
  {/each}
  <p class="muted">{INSTALL_NEEDS}</p>
  {#if error}<p role="alert">{error}</p>{/if}
  <span class="sr-only" role="status">{copied === 'Download' ? 'Download command copied' : copied ? `${copied} install command copied` : ''}</span>
</div>
<style>
  .relay-install { display: grid; gap: 8px; font-size: 12px; }
  .install-row { display: grid; grid-template-columns: minmax(0, 1fr) auto; gap: 4px 8px; align-items: center; }
  .harness { grid-column: 1 / -1; color: var(--muted); }
  pre { margin: 0; padding: 6px 8px; background: var(--code); border-radius: 6px; white-space: pre-wrap; overflow-wrap: anywhere; }
  pre code { background: none; padding: 0; font-size: 12px; }
  p { margin: 0; }
</style>
